<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.workFields')"
                :pgIcon="'bx bx-flag'"
                :refs="refs"
                :addNew="addNew">
            </Breadcrumb>


            <DataTable
                :refs="refs"
                :colspan=5

                :hasSearchFilter=true
                :hasDateFilter=true
                :hasStatusFilter=true

                :hasHashId=true
                :hasMultiSelect=false
                :hasBulkAction=true
                :HasExport=true
                :hasShowEntries=true

                :lblSearch="$t('app.search')"

                :fields="{
                    'id': 'id',
                    'title': 'title',
                    'date': 'date',
                    'status': 'status'
                }"

                :hasImage=true
                :image="$t('view.image')"
                :image_style="'width: 40px;height: 40px;border-radius: 50%'"

                :hasTitle=true
                :title="$t('view.title')"
                
                :hasDate=true
                :hasStatus=true
                :hasActions=true
                :hasDeleteButton=true

                :actionable=true
                :sorDataTable=true

                v-on:hasAddNewPermission="handlePermissoinChange">
            </DataTable>

        </div>
    </div>

</template>

<script>
export default {
    name: 'List',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        DataTable: () => import('@/components/DataTable.vue')
    },
    data(){
        return {    
            //
            addNew: false,
            refs: 'workFields',
        }
    },
    watch: {
        //
    },
    mounted() {
        //
    },
    created() {
        //
    },
    methods: {
        handlePermissoinChange(event) {
            //console.log(event)
            this.addNew = event;
        },
    },
}
</script>
